import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-duration';
const API_DETAIL = (id: number) => `/p-crm-duration/${id}`;

export interface Duration {
  id: number;
  pd_descr?: string;
  pd_min?: number;
}

export const useDurations = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<Duration[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    durations: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useDuration = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Duration>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    duration: data,
    isLoading,
    isError: error,
    mutate,
  };
};
